import Alert from "@mui/material/Alert"
import { useSelector } from "react-redux"

import { selectAdminFeatures } from "../reducer"

/** The pod admin pages, or a notice while the Pod Dialer is switched off. */
export default function PodDialerGate({ children }) {
  const features = useSelector(selectAdminFeatures)
  if (!features.pod_dialer) {
    return (
      <Alert severity="info">
        The Pod Dialer is switched off. It can be turned on from System status →
        Features in development.
      </Alert>
    )
  }
  return children
}
